module.exports = __webpack_public_path__ + "static/img/icon-4-select.3682dfb2.svg";